// src/pages/Home.tsx
import React from 'react';
import { Paper } from '@mui/material';
import { Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import Glogal from './Global';
import Instaladores from './Instaladores';
import { useAuth } from '../../context/auth';
import { AccessDenied } from '../../components/AccessDenied/Index';

const Home: React.FC = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { permisos } = useAuth();
  const { Prm_Config } = permisos;

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };
 
  if (Prm_Config === 0) {
    return <AccessDenied />;
  }

  return (
    <Paper sx={{ p: { xs: 2, sm: 3 }, minHeight: 'calc(100vh - 140px)', marginBottom: 4, overflow: 'auto', borderRadius: '26px' }}>
      <h4 style={{ margin: '0 0 14px', fontSize: '1.15rem', fontWeight: 800, letterSpacing: '-0.02em' }}>Materiales</h4>

      <Tabs value={activeTab} onChange={handleTabChange} scrollButtons='auto' variant='scrollable'>
        <Tab label='Instaladores' />
        <Tab label='Inventario global' />
      </Tabs>
      {activeTab === 0 && <Instaladores />}
      {activeTab === 1 && <Glogal />}
    </Paper>
  );
};

export default Home;
